module.exports = __webpack_public_path__ + "img/pump-30.1aa67ab7.svg";